var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import ngTranslate from 'angular-translate';
import { NgModule } from 'angular-ts-decorators';
import { LocaleModule, SUPPORTED_LANGUAGES_INJECTION_TOKEN } from '../locale/locale.module';
import { de } from './i18n/de';
import { en } from './i18n/en';
import { es } from './i18n/es';
import { fr } from './i18n/fr';
import { it } from './i18n/it';
import { UserController } from './user.controller';
import { UserService } from './user.service';
let UserModule = class UserModule {
    // Minification-safe CI injections, everything @Inject()ed somewhere must be mentioned here:
    static $inject = ['$translateProvider', SUPPORTED_LANGUAGES_INJECTION_TOKEN];
    static config($translateProvider, SUPPORTED_LANGUAGES) {
        const LOCALES = { de, en, es, fr, it };
        for (const locale of SUPPORTED_LANGUAGES) {
            $translateProvider.translations(locale, LOCALES[locale] ?? {});
        }
    }
};
UserModule = __decorate([
    NgModule({
        id: 'UserModule',
        imports: [ngTranslate, LocaleModule],
        declarations: [UserController],
        providers: [UserService],
        bootstrap: [],
    })
], UserModule);
export { UserModule };
UserModule.module.controller('UserController', UserController);
